import { Chip } from '@mui/material';
import { ReportType } from '../types';

// "Financial & staffing analysis" opens the facility tabs; "Mediation report" opens only its documents.
export default function ReportTypeChip({ type }: { type?: ReportType }) {
  const mediation = type === 'mediation';
  return (
    <Chip
      label={mediation ? 'Mediation report' : 'Financial & staffing analysis'}
      size="small"
      sx={{
        fontWeight: 600,
        fontSize: '0.7rem',
        height: 20,
        bgcolor: mediation ? '#FFF4E5' : '#E8F8FB',
        color: mediation ? '#8A4B00' : '#0D6E82',
        border: '1px solid',
        borderColor: mediation ? '#FFD8A8' : '#B6E6EF',
      }}
    />
  );
}
